/* subscription-qty-lock-month.js
 * Single source of truth for Loop subscription upgrade banners + qty lock.
 *
 * WHAT CHANGED vs the old 2-script file:
 *  - REMOVED the second click handler + forceQtyAfterUpgrade poller (Script A).
 *    Two writers on one click was the race that forced the line to qty 3.
 *  - onActivate is now the ONLY upgrade handler. Quantity is read from the
 *    banner's VISIBLE TEXT ("6 Bottles" -> 6), not data-plan-qty, because the
 *    6-bottle banner's data-plan-qty was resolving to 3.
 *  - The cart always re-renders from /?sections=header-cart (real server cart),
 *    so the stepper can never show a number the server doesn't actually have.
 *  - Price is hidden on the active line during the switch to kill the flash.
 */
(function () {
  'use strict';

  var _root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // ── CSS: qty lock + switch loading state ──
  var style = document.createElement('style');
  style.textContent = [
    '.sub-qty-locked .prd-quantity-btn{pointer-events:none!important;opacity:.4!important;cursor:not-allowed!important;}',
    '.sub-qty-locked input[name="updates[]"]{pointer-events:none!important;opacity:.6!important;user-select:none!important;}',
    '.minicart-prd{position:relative;}',
    '.sub-switching{opacity:.5!important;pointer-events:none!important;transition:opacity .2s;}',
    '.sub-switching .minicart-prd-price,.sub-switching [class*="price"]{visibility:hidden!important;}'
  ].join('');
  document.head.appendChild(style);

  /* ===================================================================
   * PART 1 — QTY LOCK (prevents manual +/- on subscription lines)
   * Derives lock qty from plan text, but never writes to the server.
   * Because PART 2 now sets the correct server qty, the locked display
   * always matches the real line — no more cosmetic "6" over a real "3".
   * =================================================================== */
  var _applying = false;

  function getPlanText(item) {
    var sels = ['.prd-plan-name', '.loop-plan-name', '.prd-prepay-text', '[data-plan-name]', '.minicart-prd-plan', '.cart-prd-plan'];
    for (var i = 0; i < sels.length; i++) {
      var el = item.querySelector(sels[i]);
      if (el) {
        var t = el.textContent.trim().toLowerCase();
        if (t && t.indexOf('upgrade to') !== 0 && t.indexOf('subscribe &') !== 0) return t;
      }
    }
    var els = item.querySelectorAll('span,p,div,a');
    for (var j = 0; j < els.length; j++) {
      var txt = els[j].textContent.trim().toLowerCase();
      if ((txt.indexOf('bottle') !== -1 || txt.indexOf('box') !== -1) && txt.indexOf('subscription') !== -1 && txt.length < 80) return txt;
    }
    return null;
  }

  function getBottleQty(t) {
    if (!t) return null;
    t = t.toLowerCase();
    var m = t.match(/(\d+)\s*(bottle|box)/);
    if (m) return parseInt(m[1], 10);
    if (/subscription|autoship|subscribe/.test(t)) return 'sub';
    return null;
  }

  function resolveLockedQty(planText, inputQty) {
    if (!planText) return null;
    var nameQty = getBottleQty(planText);
    var iq = parseInt(inputQty, 10) || 1;
    if (nameQty !== null && nameQty !== 'sub' && nameQty > 0) return iq > nameQty ? iq : nameQty;
    if (nameQty === 'sub') return iq > 0 ? iq : 1;
    return null;
  }

  function applySubscriptionRules() {
    if (_applying) return;
    _applying = true;
    try {
      var items = [].concat(
        Array.prototype.slice.call(document.querySelectorAll('#header-cart .minicart-prd')),
        Array.prototype.slice.call(document.querySelectorAll('.cart-table-prd'))
      );
      items.forEach(function (item) {
        var qtyWrap  = item.querySelector('[data-render^="qty"]');
        var input    = item.querySelector('input[name="updates[]"]');
        var minusBtn = item.querySelector('.prd-quantity-down');
        var plusBtn  = item.querySelector('.prd-quantity-up');
        var planText = getPlanText(item);
        var curQty   = input ? parseInt(input.value, 10) || 1 : 1;
        var lockedQty = resolveLockedQty(planText, curQty);

        if (lockedQty === null) {
          if (qtyWrap)  qtyWrap.classList.remove('sub-qty-locked');
          if (minusBtn) minusBtn.disabled = false;
          if (plusBtn)  plusBtn.disabled  = false;
          if (input) { input.readOnly = false; input.removeAttribute('max'); input.removeAttribute('min'); }
          return;
        }
        if (!input) return;
        if (parseInt(input.value, 10) !== lockedQty) input.value = lockedQty;
        input.readOnly = true;
        input.setAttribute('min', lockedQty);
        input.setAttribute('max', lockedQty);
        if (qtyWrap)  qtyWrap.classList.add('sub-qty-locked');
        if (minusBtn) minusBtn.disabled = true;
        if (plusBtn)  plusBtn.disabled  = true;
        [minusBtn, plusBtn].forEach(function (btn) {
          if (!btn || btn._subLocked) return;
          btn._subLocked = true;
          btn.addEventListener('click', function (e) { e.preventDefault(); e.stopImmediatePropagation(); }, true);
        });
        if (!input._subObserved) {
          input._subObserved = true;
          var lq = lockedQty;
          var keep = function () { if (parseInt(input.value, 10) !== lq) input.value = lq; };
          input.addEventListener('change', keep);
          input.addEventListener('input', keep);
        }
      });
    } finally { _applying = false; }
  }

  /* ===================================================================
   * PART 2 — UPGRADE / SUBSCRIBE BANNER (single handler)
   * =================================================================== */
  function bindBanners() {
    document.querySelectorAll('[data-loop-sub-banner]').forEach(function (el) {
      if (el._loopBound) return;
      el._loopBound = true;
      el.addEventListener('click', onActivate);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onActivate.call(el); }
      });
    });
  }

  // Quantity comes from the banner's visible text first ("6 Bottles" -> 6).
  // data-plan-qty is only a last-resort fallback because it has been wrong.
  function resolveBannerQty(banner, bannerType) {
    if (bannerType.indexOf('upgrade') !== -1) {
      var m = (banner.textContent || '').toLowerCase().match(/(\d+)\s*(bottle|box)/);
      if (m) return parseInt(m[1], 10);
      var planQty = parseInt(banner.dataset.planQty, 10);
      if (planQty) return planQty;
      return bannerType === 'monthly-upgrade' ? 3 : 6; // legacy fallback
    }
    // OTP -> subscribe: keep whatever qty is in the cart line
    var line = banner.closest('.minicart-prd');
    var input = line && (
      line.querySelector('input[name="updates[]"]') ||
      line.querySelector('.qty__num') ||
      line.querySelector('input[type="number"]') ||
      line.querySelector('.js-qty-num')
    );
    return input ? (parseInt(input.value, 10) || 1) : (parseInt(banner.dataset.quantity, 10) || 1);
  }

  function onActivate(e) {
    var banner      = this;
    var variantId   = parseInt(banner.dataset.variantId, 10);
    var sellingPlan = parseInt(banner.dataset.sellingPlan, 10) || null;
    var itemKey     = banner.dataset.key;
    var bannerType  = banner.dataset.bannerType || 'otp';
    var quantity    = resolveBannerQty(banner, bannerType);

    if (!variantId) { console.warn('[loop-sub-banner] missing variantId', banner); return; }

    var lineEl = banner.closest('.minicart-prd');
    if (lineEl) lineEl.classList.add('sub-switching');
    setLoading(banner, true);

    // Step 1 — remove current line
    fetch(_root + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey || variantId, quantity: 0 })
    })
    // Step 2 — re-add with new plan + correct qty
    .then(function (r) {
      if (!r.ok) throw new Error('remove failed ' + r.status);
      var payload = { id: variantId, quantity: quantity };
      if (sellingPlan) payload.selling_plan = sellingPlan;
      return fetch(_root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    })
    // Step 3 — verify the server actually has the qty we asked for
    .then(function (r) {
      if (!r.ok) throw new Error('add failed ' + r.status);
      return fetch(_root + 'cart.js', { credentials: 'same-origin' }).then(function (rr) { return rr.json(); });
    })
    .then(function (cart) {
      var line = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === variantId) { line = cart.items[i]; break; }
      }
      if (line && line.quantity !== quantity && line.key) {
        // Single corrective write if Shopify merged/clamped the line
        return fetch(_root + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: quantity })
        });
      }
    })
    // Step 4 — re-render from the real server cart
    .then(function () { return fetch(_root + '?sections=header-cart').then(function (r) { return r.json(); }); })
    .then(function (data) {
      if (!data['header-cart']) throw new Error('section data missing');
      rerenderCart(data['header-cart']);
      var msg = {
        'otp':             'Subscription applied — saving on every order! 🎉',
        'monthly-upgrade': 'Upgraded to ' + quantity + ' bottles — savings unlocked! 🎉',
        '3month-upgrade':  'Upgraded to ' + quantity + ' bottles — max savings! 🎉'
      };
      showToast(msg[bannerType] || 'Plan updated! 🎉');
    })
    .catch(function (err) {
      console.error('[loop-sub-banner]', err);
      setLoading(banner, false);
      if (lineEl) lineEl.classList.remove('sub-switching');
      banner._loopBound = false;
      bindBanners();
    });
  }

  function rerenderCart(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    ['.js-contents-cart-items', '.js-minicart-drop-total', '.js-contents-free-shipping', '.js-contents-subtotal'].forEach(function (sel) {
      var fresh = tmp.querySelector(sel);
      var live  = document.querySelector(sel);
      if (fresh && live) live.innerHTML = fresh.innerHTML;
    });
    bindBanners();
    applySubscriptionRules();
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function setLoading(banner, on) {
    var txt = banner.querySelector('.loop-sub-banner__text');
    var bannerType = banner.dataset.bannerType || 'otp';
    if (on) {
      banner.classList.add('loop-sub-banner--loading');
      banner.setAttribute('aria-busy', 'true');
      if (txt) txt.textContent = 'Switching…';
    } else {
      banner.classList.remove('loop-sub-banner--loading');
      banner.removeAttribute('aria-busy');
      if (txt) {
        var labels = {
          'otp':             'Subscribe &amp; <strong>Save More</strong>',
          'monthly-upgrade': 'Upgrade to 3-Bottles &amp; <strong>Save 15%</strong>',
          '3month-upgrade':  'Upgrade to 6-Bottles &amp; <strong>Save 30%</strong>'
        };
        txt.innerHTML = labels[bannerType] || labels['otp'];
      }
    }
  }

  function showToast(msg) {
    var ex = document.querySelector('.loop-sub-toast');
    if (ex) ex.remove();
    var t = document.createElement('div');
    t.className = 'loop-sub-toast';
    t.textContent = msg;
    Object.assign(t.style, {
      position: 'fixed', bottom: '24px', left: '50%', transform: 'translateX(-50%)',
      background: '#222', color: '#fff', padding: '10px 20px', borderRadius: '6px',
      fontSize: '14px', zIndex: '99999', opacity: '0', transition: 'opacity .3s', whiteSpace: 'nowrap'
    });
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.style.opacity = '1'; });
    setTimeout(function () { t.style.opacity = '0'; setTimeout(function () { t.remove(); }, 350); }, 3500);
  }

  /* ── Init ── */
  function init() { bindBanners(); applySubscriptionRules(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('cart:refresh', function () { setTimeout(function () { bindBanners(); applySubscriptionRules(); }, 350); });

  var observer = new MutationObserver(function () { bindBanners(); applySubscriptionRules(); });
  observer.observe(document.body, { childList: true, subtree: true });

})();
